import Header from '../../containers/Header'
import Turmas from '../../containers/Turmas'

import Menu from '../../components/Menu'
import Carousel from '../../components/Carousel'
import Avisos from '../../components/Avisos'
import Sobre from '../../components/Sobre'
import Contato from '../../components/Contato'
import ContatoTabletDesktop from '../../components/ContatoTabletDesktop'
import Footer from '../../components/Footer'

const Home = () => {
  return (
    <>
      <Header />
      <Menu />
      <Carousel />
      <Avisos />
      <Sobre />
      <Turmas />
      <div className="d-md-none">
        <Contato />
      </div>
      <div className="d-none d-md-block">
        <ContatoTabletDesktop />
      </div>
      <Footer />
    </>
  )
}

export default Home
